import Login from '@/views/public/login'
import Register from '@/views/public/register'
import Message from '@/views/public/message'
import PasswordRecover from '@/views/public/password-recover'
import PasswordRecoverToken from '@/views/public/password-recover-token'
import RegisterNewPassword from '@/views/public/password-new'
import Block from '@/views/public/block'

var routes =  [
   
    {
        path: '/',
        name: 'login',
        component: Login,
        meta: {
        },
    },
    {
        path: '/criar-conta',
        name: 'register',
        component: Register,
        meta: {
        },
    },
    {
        path: '/mensagem',
        name: 'message',
        component: Message,
        meta: {
        },
    },
    {
        path: '/usuario-bloqueado',
        name: 'block',
        component: Block,
        meta: {
        },
    },
    {
        path: '/lembrar-senha',
        name: 'password-recover',
        component: PasswordRecover,
        meta: {
        },
    },
    {
        path: '/validar-token',
        name: 'password-recover-token',
        component: PasswordRecoverToken,
        meta: {
        },
    },
    {
        path: '/alterar-senha',
        name: 'register-new-password',
        component: RegisterNewPassword,
        meta: {
        },
    },
    
]

export { routes }